function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-231 -828)",
  fillRule: "nonzero",
  stroke: "#f00",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m248.43 839.05l-7.1604 7.832c-0.068435 0.075246-0.16569 0.11465-0.26653 0.11465-0.10086 0-0.1981-0.039406-0.26653-0.11465l-7.1604-7.832c-2.0999-2.293-2.0999-6.0227 0-8.3157 1.0229-1.1214 2.388-1.7377 3.8431-1.7377 1.3327 0 2.5933 0.51592 3.5838 1.4654 0.9905-0.94943 2.2475-1.4654 3.5802-1.4654 1.4551 0 2.8238 0.61623 3.8503 1.7377 2.0926 2.293 2.089 6.0227-0.003606 8.3157z"
})));

function SvgIconHeartOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartOutline);
export default __webpack_public_path__ + "static/media/icon-heart-outline.b93dd33d.svg";
export { ForwardRef as ReactComponent };